import { format } from '@bilibili-maoer/web-utils'

import { useMemo } from 'react'

import { styled } from '@mui/material'
import moment from 'moment'

import { LineChart, LineChartProps } from '~/features/guild/components/charts'
import { RoomReportInfoDataItem } from '~/features/room/report/types'
import { MilliSeconds } from '~/shared/types/base/units'

const StyledChartWrapper = styled('div')`
  width: 100%;
`

const CHARTS_CONFIG: Record<
  keyof Omit<RoomReportInfoDataItem, 'bizdate' | 'unfollowed_fans_num'>,
  LineChartProps<string, number>
> = {
  live_duration: {
    tooltip: {
      // 由于「开播明细表格」对「直播时长」做了 Math.floor 处理，这里也用 Math.floor 统一显示效果
      valueFormatter: (value: number) =>
        `${value ? Math.floor(value) : '--'} 分钟（${format.formatDuration(value * 60 * 1000, 'zh')}）`,
    },
    series: {
      name: '直播时长（分钟）',
    },
  },
  new_fans_num: {
    series: {
      name: '日新增粉丝数',
    },
  },
  listener_duration_avg: {
    series: {
      name: '日人均收听时长（分钟）',
    },
  },
  listener_duration_more_than_five_minutes_ratio: {
    tooltip: {
      valueFormatter: (value: number) => `${value || '0'}%`,
    },
    series: {
      name: '日超 5 分钟收听占比',
    },
  },
}

export const GuildReportInfoLineCharts = (props: {
  chartData: RoomReportInfoDataItem[]
  activeChartField: keyof Omit<RoomReportInfoDataItem, 'bizdate' | 'unfollowed_fans_num'>
  startTime: MilliSeconds
  endTime: MilliSeconds
  loading: boolean
}) => {
  const selectedChartConfig = CHARTS_CONFIG[props.activeChartField]

  if (!selectedChartConfig.xAxis) {
    selectedChartConfig.xAxis = {}
  }

  const xAxisData = useMemo(
    () => props.chartData.map((item) => moment(item.bizdate).format('MM 月 DD 日')),
    [props.chartData]
  )
  const seriesData = useMemo(
    () => props.chartData.map((item) => item[props.activeChartField]),
    [props.chartData, props.activeChartField]
  )

  return (
    <StyledChartWrapper>
      <LineChart
        xAxis={{
          ...selectedChartConfig.xAxis,
          data: xAxisData,
        }}
        yAxis={selectedChartConfig.yAxis}
        series={{
          ...selectedChartConfig.series,
          data: seriesData,
        }}
        tooltip={selectedChartConfig.tooltip}
        grid={selectedChartConfig.grid}
        loading={props.loading}
      />
    </StyledChartWrapper>
  )
}
